import React from "react";
import { DialogContent, Grid, Tooltip, IconButton, Box } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

function UploadFileSection(props) {
  const { files, setFiles, ...otherProps } = props;

  const deleteFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  return (
    <Box
      border={1}
      borderRadius={4}
      // borderColor={files.length > 0 ? "primary.main" : "error.main"}
      {...otherProps}
    >
      <DialogContent>
        Please select one or more files to upload as evidence to support the adjustments.
        <br />
        Required: In the event that a LCL and Parcels transaction is added, evidence that proves the connote is valid.
        <br />
        Required: In the event that a Hourly and Linehaul Floating transaction is added, evidence that proves the time
        or km charged.
        <br />
        Optional: Evidence that assists in validating adjustments to LCL and Parcels transactions.
        <br />
        You may only upload files of the following types: pdf, jpg, png, docx, xlsx.
        <br />
        <Grid container direction="row" justify="space-evenly" alignItems="center">
          {files.map((file) => (
            <React.Fragment key={file.name}>
              <Grid item xs={6}>
                {file.name}
              </Grid>
              <Grid item xs={4}>{`${file.size} bytes`}</Grid>
              <Grid item xs={2}>
                <Tooltip title="Delete File">
                  <IconButton onClick={() => deleteFile(file.name)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>
    </Box>
  );
}

export default UploadFileSection;
